// Разжимает Uint8Array в строку.
export async function ungzipToString(byteArray: Uint8Array<ArrayBuffer>): Promise<string> {
    // 1. Create a stream from the compressed data
    const stream = new Blob([byteArray]).stream()

    // 2. Pipe the stream through a gzip decompression stream
    const decompressedStream = stream.pipeThrough(
        new DecompressionStream('gzip')
    )

    // 3. Read the decompressed data as text
    const response = new Response(decompressedStream)
    return await response.text()
}
